import ImageLoader from "../base/Image";

const ProductImages = ({ product, showImages }) => {
  console.log("ProductImages", product);
  return (
    <div className={`flex items-center justify-center space-x-2`}>
      {product.images.map((i, index) => (
        <div
          className="cursor-pointer hover:opacity-80 transition-opacity duration-100"
          onClick={showImages ? () => showImages(index) : null}
        >
          <ImageLoader key={index} size="w-20 h-20 z-0" src={i.url} />
        </div>
      ))}
    </div>
  );
};

export const ProductImagesV2 = ({ images, size = "w-12 h-12" }) => {
  return (
    <div className="flex flex-wrap">
      {images.map((i) => (
        <img
          className={`mr-2 mb-2 rounded-lg ${size}`}
          alt={i.url}
          src={i.url}
          key={i.id}
        />
      ))}
    </div>
  );
};

export default ProductImages;
